module.exports = __webpack_public_path__ + "static/media/laptop3.cf2c707b.jpg";